/**
 * @description 檢核保期(保發/關貿) 狀態對應
*/
export enum VehiclePolicyStatus {
    /** 無保單資料 */
    None = '0',
    /** 未過期，保期 90 天內 */
    UnExpiredMin = '1',
    /** 未過期，保期 大於 90 天 */
    UnExpiredMax = '2',
    /** 已過期 */
    Expired = '3'
}
